

import { Component, Injector } from '@angular/core';
import { ViewController, NavParams, LoadingController } from "ionic-angular";
import { Util } from '../../app/util';
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the ModalfasixPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-modalfasix',
  templateUrl: 'modalfasix.html',
})
export class ModalfasixPage extends Util {

  constructor(public viewCtrl: ViewController, public navpar: NavParams, public inj: Injector, loading: LoadingController,public translate:TranslateService) {
    super(inj, loading);
    this.fasi = this.navpar.get('fasi');
    this.mj = this.navpar.get('mj');
    // console.log(this.fasi);
    // this.img_data = this.navpar.get('img_data'); 
    // this.badge = this.navpar.get('testo');
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ModalfasixPage');
  }

  fasi;
  mj;
  

  response(res) {
    this.viewCtrl.dismiss(res);
  }
  // scarica() {
  //   // console.log(this.badge);
  //   this.GetRequest('linkBadge', this.badge.identfier).then((x: any) => {
  //     if (x != null && x.pdf != null) {
  //       const linkSource = `data:application/pdf;base64,${x.pdf}`;
  //       const downloadLink = document.createElement("a");
  //       const fileName = x.filename;

  //       downloadLink.href = linkSource;
  //       downloadLink.download = fileName;
  //       downloadLink.click();
  //     }

  //   }).catch((err) => {
  //     console.log(err);
  //   });




  //   //this.open_in_app_browser(this.urlserver+ 'linkBadge/'+ this.badge.identfier);
  // }
}



// WEBPACK FOOTER //
// ./src/pages/modalfasix/modalfasix.ts